'use strict';

// For building urls like baltimore.orioles.mlb.com and m.orioles.mlb.com:
let rawUrlSegments = {/* e.g. bal: ['baltimore', 'orioles'] */};

// Tricodes (statsapi fileCodes) to [statsapi teamCode, statsapi abbreviation]
const fileCodesToCodes = {/* e.g. sd: ['sdn', 'sd'] */};

const BASE_JSP_LEAGUE_URL = 'http://mlb.mlb.com';
const BASE_V2_LEAGUE_URL = 'http://m.mlb.com';

let initted = false;

/**
 * @private
 */
class LegacyData {

    /**
     * Inits the LegacyData object; populates its mappings (rawUrlSegments and fileCodesToCodes)
     * @param activeTeamsArr
     */
    static init(activeTeamsArr) {
        if (!initted) {
            initted = true;
        }
        var teamLoc;
        var teamName;
        let team;
        for (let i = 0, ln = activeTeamsArr.length; i < ln; i++) {
            team = activeTeamsArr[i];
            // This is ugly: we don't have anything in the data that will give us the team's location, so we can
            // do, for example, newyork.yankees.  The "locationName" for NYY is "Bronx", for example.  The "shortName"
            // works except for cities that have two teams (thus NYY's shortName is "NY Yankees").  Parsing "name" (e.g.
            // "New York Yankees") doesn't work because we don't know which space char to split on (plus that wouldn't
            // be non-English-friendly).  So, for now, until we have a field that gives us what we need, we'll go with
            // "locationName" and override in the cases where that's necessary:
            let locationOverrides = {
                140: 'Texas',
                142: 'Minnesota',
                147: 'New York', // Yankees; Mets are fine
                108: 'Los Angeles', // Angels; Dodgers are fine
                109: 'Arizona',
                115: 'Colorado'
            };
            teamLoc = (locationOverrides[team.id] || team.locationName);

            // More ugliness; this is just for legacy stuff, plus the data just doesn't help here:
            teamName = (team.teamName === 'D-backs' ? 'Diamondbacks' : team.teamName);


            rawUrlSegments[team.fileCode] = [
                LegacyData._getLegacyHostnameSlug(teamLoc),
                LegacyData._getLegacyHostnameSlug(teamName)
            ];
            fileCodesToCodes[team.fileCode] = [team.teamCode, team.abbreviation.toLowerCase()];
        }
    }

    /**
     * Returns a base URL for the specified team in one of two formats: http://newyork.yankees.mlb.com (if jsp=true),
     * http://m.yankees.mlb.com (if jsp=false, i.e. if it's a v2 URL)
     * @param tricode Technically, the team's statsapi fileCode (ana not laa; la not lad; etc.)
     * @param jsp True for JSP site, false for v2 site
     * @return {string} a URL in one of two formats
     * @private
     */
    static _getBaseUrlFromTricode(tricode, jsp) {
        LegacyData.inittedCheck('_getBaseUrlFromTricode');
        let code = (tricode || '').toLowerCase();
        if (!code || tricode === 'mlb') {
            return (jsp ? BASE_JSP_LEAGUE_URL : BASE_V2_LEAGUE_URL);
        }

        let entry = rawUrlSegments[tricode];
        if (!entry) {
            throw new Error('No team found for tricode ' + code);
        }
        return 'http://' + (jsp ? entry[0] : 'm') + '.' + entry[1] + '.mlb.com';
    }

    /**
     * Processes calls to _getTeamCodeFromTricode() and _getAbbreviationFromTricode()
     * @param tricode Technically, the team's statsapi fileCode (ana not LAA; la not LAD; etc.)
     * @param {'teamCode' | 'abbreviation'} codeType
     * @return a teamCode or abbreviation, or null if unrecognized team
     * @private
     */
    static _getCodeFromTricode(tricode, codeType) {
        LegacyData.inittedCheck('_getCodeFromTricode');
        if (rawUrlSegments[tricode] === undefined) {
            return null;
        }

        // We're here, so the team exists.  It may or may not be in the poorly named fileCodesToCodes map; teams
        // whose tricodes (statsapi fileCodes) are the same as both their teamCodes and abbreviations are not in that
        // map; we just return the tricode in those cases (uppercased if request is for an abbreviation).

        let code;
        if (fileCodesToCodes[tricode] === undefined) {
            code = tricode;
        } else {
            let indices = {
                teamCode: 0,
                abbreviation: 1
            };
            code = fileCodesToCodes[tricode][indices[codeType]];
        }

        return (codeType === 'abbreviation' ? code.toUpperCase() : code);
    }

    static _getLegacyHostnameSlug(str) {
        LegacyData.inittedCheck('_getLegacyHostnameSlug');
        let slug = str.toLowerCase().trim().replace(/[^a-z]/g, '');

        // special case for diamondbacks > dbacks:
        return (slug === 'diamondbacks' ? 'dbacks' : slug);
    }

    /**
     * Throws an exception if LegacyData.init() hasn't been called
     * @param callerFnName
     * @private
     */
    static inittedCheck(callerFnName) {
        if (!initted) {
            throw new Error('Cannot call LegacyData.' + callerFnName + '() until LegacyData.init() has been called.');
        }
    }
}

export default LegacyData;



